<section style="height: auto;" translate="no">
  <nav>
    <ol class="divbusca">
      <div class="div_busca_orientacao">
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="regiao" class="form-label">Região:</label>
          </div>
          <div class="tdCampo">
            <select (change)="onSelecionar(mySelectFiltroRegiao.value)" #mySelectFiltroRegiao name="select"
              aria-placeholder="Regiao" class="form-select">
              <option value="">Todos</option>
              <option *ngFor="let objeto of listaRegiao" value={{objeto.id}}>{{objeto.descricao}}</option>

            </select>
          </div>
        </div>
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="posto" class="form-label">Posto:</label>
          </div>
          <div class="tdCampo">
            <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/2.8" [SemOpTodos]="true"
              [regiaoSelecionada]="RegiaoSelecionada"
              (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
          </div>
        </div>
        <div class="tdTitilo">
          <button class="btn btn-primary btnpesquisa" (click)="filtrarPesquisa()" id="class-button"
            type="submit">Pesquisar</button>
        </div>
      </div>
    </ol>
  </nav>
</section>
<section translate="no">
  <section style="height: auto;">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                Relatório de Vagas Desproporcionais
              </td>
            </tr>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  @if(feitaPesquisa)
  {
  <h4 class="alerta_busca">Escolha um
    posto para visualizar o relatório
  </h4>
  }
  @if(!feitaPesquisa)
  {
  <div class="div_buttons">
    <button type="button" (click)="exportToPDF()" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar PDF<i class="fas fa-file-pdf fa-2xl" style="margin-left: 10px;"></i>
    </button>
    <button (click)="exportarParaExcel()" type="button" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar Excel
      <i class="fas fa-file-excel fa-2xl" style="margin-left: 10px;"></i>
    </button>
  </div>
  }
  @for (item of data; track item) {
  <ul class="ul_relatorio">
    <li>

      
        <div class="gh-table">
          <div id="gridHeat" style="width: 100%; max-width: 94vw;">
            <div class="div-title tooltip" style="    z-index: auto;">
              <div>
                <h4 class="card-title">{{ item.descricao }}</h4>
              </div>
            </div>
            <div class="tabela-wrapper">
            @if(hasNoServicosComDias(item))
            {
            <div class="div-value" style="max-height: 500px;">
              <div style="width: 100%;justify-content: center;display: grid;background-color: rgb(238, 238, 238);">
                <div style="width: 100%;position: sticky !important;">
                  <div style="width: 100%;background-color: rgb(238, 238, 238);">
                    <div class="gh-value">Sem dados de vagas desproporcionais</div>
                  </div>
                </div>
              </div>
            </div>
            }
            @else{
            <div class="div-value" style="max-height: 500px;">
              <div class="gh-row">
                <!-- Órgão -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabelaOrgao()">
                    <div class="gh-value">
                      Órgão                     
                      {{
                        campoOrdenado === 'orgao'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              
                <!-- Serviço -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabelaServico()">
                    <div class="gh-value">
                      Serviço                     
                      {{
                        campoOrdenado === 'servico'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              
                <!-- Data -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabela('dia')">
                    <div class="gh-value">
                      Data
                      {{
                        campoOrdenado === 'dia'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              
                <!-- Total do Dia -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabela('totalDia')">
                    <div class="gh-value">
                      Total do dia
                      {{
                        campoOrdenado === 'totalDia'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              
                <!-- Total do Período -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabela('totalPeriodo')">
                    <div class="gh-value">
                      Total do Período
                      {{
                        campoOrdenado === 'totalPeriodo'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              
                <!-- Dias com Registros -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabela('numeroDias')">
                    <div class="gh-value">
                      Dias com registros                      
                      {{
                        campoOrdenado === 'numeroDias'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              
                <!-- Média -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabela('mediaDia')">
                    <div class="gh-value">
                      Média                      
                      {{
                        campoOrdenado === 'mediaDia'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              
                <!-- Diferença -->
                <div class="gh-cell" style="position: sticky !important;">
                  <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarTabela('diferenca')">
                    <div class="gh-value">
                      Diferença                     
                      {{
                        campoOrdenado === 'diferenca'
                          ? (ordem === 'asc' ? '▲' : '▼')
                          : '⇅'
                      }}
                    </div>
                  </div>
                </div>
              </div>
              
              @for(objOrg of item.orgaos; track objOrg; let indexLine = $index){

              @for(objSer of objOrg.servicos; track objSer; let indexLine2 = $index){
              @for (dia of objSer.dias; track dia; let indexCol = $index) {

              <div class="gh-row">
                @if(isPrimeiroComDia(objOrg.servicos, indexLine2) && indexCol == 0){
                <div class="gh-cell rowLabel"
                  style="min-width: 200px;width: 300px;background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{ objOrg.descricao }}</span>
                </div>
                }
                @else
                {
                <div class="gh-cell rowLabel"
                  style="min-width: 200px; width: 300px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'></span>
                </div>
                }

                @if(indexCol == 0){
                <div class="gh-cell rowLabel"
                  style="min-width: 150px;width: 300px;background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{ objSer.descricao }}</span>
                </div>
                }
                @else
                {
                <div class="gh-cell rowLabel"
                  style="min-width: 200px; width: 150px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'></span>
                </div>
                }
                <div class="gh-cell rowLabel"
                  style="min-width: 150px;width: 100%;left: 0px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{ dateTimeFormatPipe.transformSemHoraEAno(dia.dia) }}</span>
                </div>
                <div class="gh-cell rowLabel"
                  style="min-width: 150px;width: 100%;left: 0px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{dia.totalDia }}</span>
                </div>
                <div class="gh-cell rowLabel"
                  style="min-width: 150px;width: 100%;left: 0px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{dia.totalPeriodo }}</span>
                </div>
                <div class="gh-cell rowLabel"
                  style="min-width: 150px;width: 100%;left: 0px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{dia.numeroDias }}</span>
                </div>
                <div class="gh-cell rowLabel"
                  style="min-width: 150px;width: 100%;left: 0px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{dia.mediaDia }}</span>
                </div>
                <div class="gh-cell rowLabel"
                  style="min-width: 150px;width: 100%;left: 0px; background-color: rgb(238, 238, 238);">
                  <span class='gh-value'>{{dia.diferenca }}</span>
                </div>
              </div>
              }
              }
              }
            </div>
            }
          </div>
        </div>

      </div>
    </li>
  </ul>

  }